import { useEffect, useMemo, useState } from "react";

import { toBlob } from "components/config/helpers";

import { FILE_PREVIEW_MAX_SIZE } from "./constants/values";

export const useCheckFileMaxSize = (
  originalFile: string,
  maxFileSize: number = FILE_PREVIEW_MAX_SIZE
) => {
  const [fileContent, setFileContent] = useState<string>("");

  const blob = useMemo(() => toBlob(originalFile), [originalFile]);
  const exceedsFileSize = blob.size > maxFileSize;

  useEffect(() => {
    const parseFileContent = async () => {
      if (exceedsFileSize) {
        setFileContent("");
        return;
      }
      const content = await blob.text();
      setFileContent(content);
    };
    parseFileContent();
  }, [blob, exceedsFileSize]);

  return {
    fileContent,
    exceedsFileSize,
  };
};
